var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyassessment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3496 3.15039V5.15039H20.0068C20.1959 5.15039 20.3496 5.30415 20.3496 5.49316V21.5068C20.3494 21.5978 20.3133 21.6847 20.249 21.749C20.1846 21.8135 20.097 21.8495 20.0059 21.8496H3.99316C3.90219 21.8496 3.81432 21.8143 3.75 21.75C3.68568 21.6857 3.65039 21.5978 3.65039 21.5068V5.49316C3.65039 5.30415 3.80415 5.15039 3.99316 5.15039H7.65039V3.15039H16.3496ZM4.34961 21.1504H19.6504V5.84961H16.3496V7.84961H7.65039V5.84961H4.34961V21.1504ZM8.34961 17.1504V17.8496H7.65039V17.1504H8.34961ZM8.34961 14.1504V14.8496H7.65039V14.1504H8.34961ZM8.34961 11.1504V11.8496H7.65039V11.1504H8.34961ZM8.34961 7.15039H15.6504V3.84961H8.34961V7.15039Z",
    stroke: "#181818",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyassessment);
export default __webpack_public_path__ + "static/media/surveyassessment.8bcf6c7f80f0f4620fe140e1e70e36c1.svg";
export { ForwardRef as ReactComponent };